/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ years: NonNullable<unknown> }} Tld_Pricing_Enabled_LabelInputs */

const id_tld_pricing_enabled_label = /** @type {(inputs: Tld_Pricing_Enabled_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktifkan ${i?.years} tahun`)
};

const en_tld_pricing_enabled_label = /** @type {(inputs: Tld_Pricing_Enabled_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enable ${i?.years} yr`)
};

/**
* | output |
* | --- |
* | "Enable {years} yr" |
*
* @param {Tld_Pricing_Enabled_LabelInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_enabled_label = /** @type {((inputs: Tld_Pricing_Enabled_LabelInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Enabled_LabelInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_enabled_label(inputs)
	return id_tld_pricing_enabled_label(inputs)
});